import React, { useState } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogMLStyled from './DialogMLStyled';
import { useTheme } from '@material-ui/core';
import { useIntl } from 'umi';
import CircularProgress from '@material-ui/core/CircularProgress';

const DialogML = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    open,
    handleClose,
    handleSure,
    describe,
    title,
    specilaAlgorithmLabValue,
    minwidthinit,
    maxwidthinit,
    minheightinit,
    bp,
    disabled,
    pageSource = '',
    buttonStyle,
  } = props;
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  return (
    <DialogMLStyled
      theme={theme}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={'md'}
      minwidthinit={minwidthinit}
      minheightinit={minheightinit}
      maxwidthinit={maxwidthinit}
      bp={bp}
      pageSource={pageSource}
      buttonStyle={buttonStyle}
    >
      <DialogTitle id="alert-dialog-title" className={'title'}>
        <span className={'titleText'}>{title}</span>
      </DialogTitle>
      <DialogContent className="content">
        <DialogContentText id="alert-dialog-description">
          {describe}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={'buttonWrapper'}>
        <Button
          disabled={disabled}
          onClick={() => {
            handleClose();
          }}
          className="delete button"
          variant="contained"
          // startIcon={<CloseIcon className="icon-font-size" />}
        >
          {formatMessage({ id: 'comm.action.btn.08' })}
        </Button>
        <div className="ensure-button">
          <Button
            className="save button"
            onClick={() => {
              handleSure && handleSure();
              setLoading(true);
              // handleDelete();
              setTimeout(() => {
                setLoading(false);
                handleClose(specilaAlgorithmLabValue);
              }, 500);
            }}
            // startIcon={<CheckIcon className="icon-font-size" />}
            disabled={disabled || loading}
            variant="contained"
          >
            {formatMessage({ id: 'comm.action.btn.07' })}
          </Button>
          {loading && <CircularProgress size={24} className="buttonProgress" />}
        </div>
      </DialogActions>
    </DialogMLStyled>
  );
};

export default DialogML;
